"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[450],{

/***/ 6651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CategoriesSection; }
});

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(1225);
// EXTERNAL MODULE: ./src/components/Title/index.tsx + 1 modules
var Title = __webpack_require__(2422);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/CategoriesSection/icons.tsx


function Carrer() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "54",
    height: "54",
    fill: "none",
    viewBox: "0 0 54 54",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
      cx: "27",
      cy: "27",
      r: "26.5",
      fill: "#fff",
      stroke: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      stroke: "#00F",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      clipPath: "url(#clip0_214_129)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M15.996 24.16a3.055 3.055 0 100-6.11 3.055 3.055 0 000 6.11zM11.05 39.144v-10.79a2.722 2.722 0 011.906-2.598h6.095a2.533 2.533 0 012.025 1.019l2.839 3.583 7.959.313a2.804 2.804 0 01-2.856 2.801H21.98l-3.91-2.618M20.215 34.198v4.946"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M20.72 24.578l2.518-8.925a.905.905 0 01.873-.657h17.91a.904.904 0 01.872 1.149L39.79 27.14a.905.905 0 01-.872.657H23.852M20.943 24.015l15.566-.065"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M31.998 27.797v1.384a5.617 5.617 0 001.727 4.05v0M28.362 27.797v1.31M23.706 33.47h19.349M9.596 39.58h21.966M30.737 16.596h-5.566a.225.225 0 00-.215.16L23.9 20.384a.224.224 0 00.112.267.223.223 0 00.102.024h5.56a.223.223 0 00.214-.16l1.06-3.628a.222.222 0 00-.11-.266.224.224 0 00-.1-.025v0zM32.726 17.905h7.42M31.998 20.087h4.365"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_214_129",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: "#fff",
          d: "M0 0H33.75V24.876H0z",
          transform: "translate(9.45 14.85)"
        })
      })
    })]
  });
}
function FrontEnd() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "54",
    height: "54",
    fill: "none",
    viewBox: "0 0 54 54",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
      cx: "27",
      cy: "27",
      r: "26.5",
      fill: "#fff",
      stroke: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "#00F",
      clipPath: "url(#clip0_214_102)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M37.784 34.56h-21.6V9.72h16.961l4.64 4.633V34.56zm-20.52-1.08h19.44V14.802L32.697 10.8H17.264v22.68z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M37.26 15.12H32.4v-4.86h1.08v3.78h3.78v1.08z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M35.64 23.76H18.36V11.88h14.58v1.08h-13.5v9.72h15.12v-8.1h1.08v9.18z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M26.984 21.6a3.78 3.78 0 110-7.561 3.78 3.78 0 010 7.561zm0-6.48a2.7 2.7 0 100 5.4 2.7 2.7 0 000-5.4zM35.64 24.84H18.36v1.08h17.28v-1.08zM35.64 27H18.36v1.08h17.28V27zM26.46 29.16h-8.1v1.08h8.1v-1.08zM35.64 29.16h-8.1v1.08h8.1v-1.08zM26.46 31.32h-8.1v1.08h8.1v-1.08zM35.64 31.32h-8.1v1.08h8.1v-1.08zM34.02 43.2H19.98v1.08h14.04V43.2zM42.66 35.64H11.34v1.08h31.32v-1.08z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M32.584 44.28H21.41l1.944-6.48h7.285l1.944 6.48zm-9.72-1.08h8.267l-1.296-4.32H24.16l-1.296 4.32z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M41.623 14.04H37.39v1.08h4.233a1.577 1.577 0 011.577 1.571v19.532a1.577 1.577 0 01-1.577 1.577h-29.22a1.575 1.575 0 01-1.62-1.577V16.691a1.576 1.576 0 011.578-1.571h4.233v-1.08h-4.19a2.652 2.652 0 00-2.657 2.651v19.532a2.657 2.657 0 002.657 2.657H41.65a2.662 2.662 0 002.614-2.657V16.691a2.657 2.657 0 00-2.64-2.651z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_214_102",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: "#fff",
          d: "M0 0H34.56V34.56H0z",
          transform: "translate(9.72 9.72)"
        })
      })
    })]
  });
}
function BackEnd() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "54",
    height: "54",
    fill: "none",
    viewBox: "0 0 54 54",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
      cx: "27",
      cy: "27",
      r: "26.5",
      fill: "#fff",
      stroke: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "#00F",
      clipPath: "url(#clip0_214_43)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M33.856 40.476H20.145v1.049h13.711v-1.05zM41.282 36.284H12.718a2.603 2.603 0 01-1.833-.756 2.575 2.575 0 01-.76-1.824V14.73c0-.684.274-1.34.76-1.823a2.603 2.603 0 011.833-.756h28.564c.687 0 1.347.273 1.833.756.486.484.76 1.14.76 1.823V33.7c0 .685-.273 1.342-.759 1.826a2.603 2.603 0 01-1.834.758zM12.718 13.199c-.408 0-.799.162-1.087.449-.289.287-.45.675-.451 1.081V33.7c0 .406.162.795.45 1.082.29.287.68.448 1.088.449h28.564a1.544 1.544 0 001.084-.45c.287-.288.448-.676.449-1.08V14.728c0-.405-.163-.794-.451-1.081a1.544 1.544 0 00-1.087-.449H12.718z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M42.294 31.558H11.708v1.05h30.586v-1.05zM28.056 33.132h-2.11v1.05h2.11v-1.05zM32.455 41.525h-10.91l1.899-6.294h7.112l1.899 6.294zm-9.492-1.05h8.071l-1.262-4.191h-5.544l-1.265 4.192zM41.767 13.724h-1.055v17.31h1.055v-17.31zM13.29 13.724h-1.055v17.31h1.055v-17.31zM22.04 28.017c-.376 0-.736-.149-1.002-.413a1.406 1.406 0 01-.415-.997V24.92a2.805 2.805 0 00-1.262-2.352l-.295-.194.295-.196a2.806 2.806 0 001.262-2.346V18.15c0-.374.15-.732.415-.997a1.422 1.422 0 011.002-.413.71.71 0 00.74-.705.703.703 0 00-.46-.66.71.71 0 00-.28-.045 2.845 2.845 0 00-2.004.827 2.815 2.815 0 00-.83 1.993v1.687a1.402 1.402 0 01-.631 1.173l-1.18.782a.706.706 0 00-.231.92c.055.102.134.189.232.253l1.179.782a1.41 1.41 0 01.63 1.173v1.687c.001.748.3 1.464.831 1.993a2.846 2.846 0 002.004.827.715.715 0 00.683-.428.703.703 0 00-.403-.937.713.713 0 00-.28-.045zM36.605 21.792l-1.18-.782a1.41 1.41 0 01-.63-1.173V18.15c-.001-.747-.3-1.464-.831-1.993a2.845 2.845 0 00-2.003-.827.711.711 0 00-.74.705.703.703 0 00.459.66c.09.034.185.05.28.045.376 0 .736.15 1.002.414.265.264.414.622.415.996v1.687a2.804 2.804 0 001.262 2.346l.295.196-.295.195a2.823 2.823 0 00-1.262 2.346v1.687c0 .374-.15.732-.415.996a1.423 1.423 0 01-1.002.414.713.713 0 00-.683.428.703.703 0 00.403.938c.09.033.185.049.28.044a2.846 2.846 0 002.004-.827c.531-.529.83-1.245.83-1.993V24.92a1.401 1.401 0 01.631-1.173l1.18-.782a.706.706 0 00.232-.92.706.706 0 00-.233-.253z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M23.457 21.673H22.04a.711.711 0 00-.68.705.704.704 0 00.68.706h1.417a.711.711 0 00.679-.706.704.704 0 00-.679-.705zM27.709 21.673H26.29a.711.711 0 00-.679.705.704.704 0 00.679.706h1.418a.711.711 0 00.678-.706.704.704 0 00-.678-.705zM32.669 22.38a.701.701 0 00-.437-.653.712.712 0 00-.271-.054h-1.418a.711.711 0 00-.679.705.704.704 0 00.679.706h1.418a.71.71 0 00.708-.705z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_214_43",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: "#fff",
          d: "M0 0H33.75V29.375H0z",
          transform: "translate(10.125 12.15)"
        })
      })
    })]
  });
}
function Institutional() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "54",
    height: "54",
    fill: "none",
    viewBox: "0 0 54 54",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
      cx: "27",
      cy: "27",
      r: "26.5",
      fill: "#fff",
      stroke: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      clipPath: "url(#clip0_214_147)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: "#00F",
        stroke: "#00F",
        strokeMiterlimit: "10",
        d: "M21.59 43.973h-6.174c-.104 0-.348 0-.48-.242-.14-.255.009-.467.065-.546l4.18-5.982h-7.452c-.43 0-.698-.265-.699-.691V30.62c0-.427.269-.693.7-.694h1.14V17.308h-1.127c-.459 0-.712-.256-.713-.716v-5.848c0-.446.266-.709.711-.709H19.4c.226 0 .403.063.528.185s.191.302.191.529v10.31l1.322-1.894 2.035-2.918 1.453-2.083a3636.18 3636.18 0 002.657-3.807.734.734 0 01.633-.327v0c2.092.003 4.166.003 6.096 0 .372 0 .547.19.628.348.082.16.137.42-.078.728a3729.996 3729.996 0 00-3.503 5.019l-4.957 7.102-.099.14c-.06.085-.119.167-.173.25.42.608.85 1.225 1.267 1.82l1.75-2.506 2.627-3.76.177-.247c.342-.489.696-.995 1.04-1.494a.584.584 0 01.511-.262c2.371.003 4.742.003 7.112 0h1.822c.35 0 .535.185.536.535v5.694c0 .352-.18.53-.537.53H41.04V37.21h1.407c.343 0 .526.183.526.528v5.694c0 .356-.179.537-.53.537h-7.738c-.374 0-.55-.178-.55-.56v-6.208h-1.2c-1.522 0-3.096 0-4.643.004a.776.776 0 01-.696-.37 13.683 13.683 0 00-.364-.525l-.435.622-1.341 1.92-1.971 2.823-.518.74c-.3.426-.61.867-.91 1.303a.56.56 0 01-.487.255v0zm-3.88-.557h3.9a338.15 338.15 0 001.442-2.06l1.968-2.826 1.34-1.92.45-.64.437-.625.227.322.183.257c.147.205.286.399.42.604.055.081.1.118.232.118 1.548-.005 3.122-.004 4.644-.003h1.755v6.769h7.708v-5.645h-1.498c-.046 0-.09 0-.129-.006h-.045l-.262-.014V23.376h1.934V17.73H33.5c-.013 0-.027 0-.04.004a.133.133 0 00-.015.018c-.345.5-.699 1.007-1.04 1.496l-.177.252-2.628 3.76-2.128 3.046-.228-.167-.013-.01a.319.319 0 01-.089-.083l-.177-.253c-.443-.643-.903-1.3-1.352-1.952a.433.433 0 01.004-.453c.076-.12.158-.235.237-.345l.096-.137 4.956-7.103 3.504-5.019c.067-.097.052-.126.04-.152-.014-.025-.025-.047-.137-.047h-6.096a.182.182 0 00-.179.09l-2.657 3.807-1.453 2.083-2.035 2.918-1.744 2.5a.69.69 0 01-.071.083l-.035.036-.48.525V10.744a.227.227 0 00-.025-.131.247.247 0 00-.14-.026v0H11.74c-.145 0-.157.023-.157.152v5.848c0 .15.011.16.161.16h1.678v13.736H11.73c-.132 0-.145.024-.145.136v5.89c0 .107.005.135.145.135h7.7c.123 0 .135-.023.135-.13v-11.06c0-.032 0-.064.004-.095l.012-.27.428-.051 4.18 5.95-.124.19a1.484 1.484 0 01-.041.062l-8.51 12.174h2.194l.004.002zm2.407-17.251v9.692l.004-.006 3.393-4.855-3.397-4.831zM34.27 36.448l-.137-.37a.656.656 0 01-.01-.032c-1.11-1.585-2.296-3.291-3.511-5.029a.4.4 0 010-.491c.869-1.24 1.737-2.482 2.605-3.724l.904-1.293a.856.856 0 01.067-.083l.033-.037.487-.568v11.258l-.438.37zm-3.153-5.678c1.044 1.493 2.067 2.96 3.034 4.345v-8.687l-.48.692c-.852 1.216-1.704 2.432-2.554 3.648v.002z"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_214_147",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: "#fff",
          d: "M0 0H32V34H0z",
          transform: "translate(11 10)"
        })
      })
    })]
  });
}
function Technology() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "54",
    height: "54",
    fill: "none",
    viewBox: "0 0 54 54",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
      cx: "27",
      cy: "27",
      r: "26.5",
      fill: "#fff",
      stroke: "#fff"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "#00F",
      clipPath: "url(#clip0_214_72)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M38.211 36.571h-1.35a.796.796 0 00-1.592 0h-1.35a2.146 2.146 0 114.292 0z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M35.269 35.471h-1.35a.803.803 0 00-1.6 0h-1.35a2.153 2.153 0 014.3 0z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M32.319 34.364h-1.35v1.471h1.35v-1.471zM35.269 35.464h-1.35v1.472h1.35v-1.472z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M26.305 46.602l-1.465-1.613a8.27 8.27 0 01-1.553-2.397l-2.956-7.236c-.33-.81.223-1.795 1.262-2.234a2.145 2.145 0 012.815 1.14l.553 1.391v-7.087a2.147 2.147 0 014.293 0l.075 4.185a2.146 2.146 0 012.977 1.984h-1.35a.796.796 0 00-1.594 0 .675.675 0 11-1.35 0l-.108-6.162a.803.803 0 10-1.593 0v10.584a.674.674 0 01-1.302.25l-1.85-4.618a.803.803 0 00-1.04-.418c-.411.175-.533.432-.533.506.71 1.721 2.248 5.474 2.943 7.189a7.1 7.1 0 001.31 2.025l1.465 1.606-1 .905zM35.755 46.575h-1.35c.056-.834.31-1.641.742-2.356l1.222-2.437a4.515 4.515 0 00.473-2.025v-3.2h1.35v3.2a5.92 5.92 0 01-.615 2.612l-1.221 2.444a4.105 4.105 0 00-.601 1.762z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M35.755 49.275h-9.801v-4.05h9.8v4.05zm-8.472-1.35h7.122v-1.35h-7.101l-.02 1.35zM20.371 33.014a8.1 8.1 0 1113.257 0l-1.107-.776a6.75 6.75 0 10-11.043 0l-1.107.776z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M31.556 32.373l-1.012-.898a4.725 4.725 0 10-7.088 0l-1.012.891a6.076 6.076 0 119.112 0v.007z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M30.712 29.97l-1.235-.54a2.7 2.7 0 10-4.955 0l-1.235.54a4.05 4.05 0 117.425 0z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M18.994 34.614a9.99 9.99 0 01-2.173-6.264 10.124 10.124 0 1118.9 5.063l-1.168-.675a8.775 8.775 0 10-14.492 1.04l-1.067.836zM26.98 14.175a3.374 3.374 0 110-6.75 3.374 3.374 0 010 6.75zm0-5.4a2.025 2.025 0 100 4.05 2.025 2.025 0 000-4.05z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M27.675 10.125h-1.35v1.35h1.35v-1.35zM27.675 13.5h-1.35v5.4h1.35v-5.4zM14.114 19.514a3.375 3.375 0 111.291-6.494c.41.17.78.421 1.092.736a3.375 3.375 0 01-2.383 5.758zm0-5.4a2.024 2.024 0 00-1.43 3.456 2.079 2.079 0 002.861 0 2.025 2.025 0 000-2.862 2.025 2.025 0 00-1.43-.594z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M14.113 15.182l-.954.954.954.955.955-.955-.955-.954zM16.5 17.575l-.955.954 3.819 3.819.954-.955-3.818-3.818zM8.755 32.4a3.375 3.375 0 110-6.75 3.375 3.375 0 010 6.75zm0-5.4a2.025 2.025 0 100 4.05 2.025 2.025 0 000-4.05z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M9.45 28.35H8.1v1.35h1.35v-1.35zM17.55 28.35h-6.075v1.35h6.075v-1.35zM45.205 32.4a3.374 3.374 0 110-6.749 3.374 3.374 0 010 6.749zm0-5.4a2.025 2.025 0 100 4.05 2.025 2.025 0 000-4.05z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M45.9 28.35h-1.35v1.35h1.35v-1.35zM42.525 28.35H36.45v1.35h6.075v-1.35zM39.886 19.514a3.375 3.375 0 01-2.383-5.758 3.375 3.375 0 015.758 2.383 3.375 3.375 0 01-3.375 3.375zm0-5.4a2.025 2.025 0 00-1.431 3.456 2.079 2.079 0 002.862 0 2.024 2.024 0 00-1.431-3.456z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M39.89 15.183l-.955.955.955.954.954-.954-.954-.955zM37.494 17.561l-3.818 3.819.954.954 3.819-3.818-.955-.954z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_214_72",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: "#fff",
          d: "M0 0H43.2V41.85H0z",
          transform: "translate(5.4 7.425)"
        })
      })
    })]
  });
}
function Arrow() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "56",
    height: "16",
    fill: "none",
    viewBox: "0 0 56 16",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fill: "#fff",
      d: "M55.48 8.707a1 1 0 000-1.414L49.117.929a1 1 0 00-1.415 1.414L53.36 8l-5.657 5.657a1 1 0 001.415 1.414l6.363-6.364zM0 9h54.773V7H0v2z"
    })
  });
}
;// CONCATENATED MODULE: ./src/components/CategoriesSection/list.tsx


var categoriesList = [{
  name: 'Carreira',
  slug: 'carreira',
  color: '#0000FF',
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(Carrer, {})
}, {
  name: 'Front-End',
  slug: 'front-end',
  color: '#FA463C',
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(FrontEnd, {})
}, {
  name: 'Back-End',
  slug: 'back-end',
  color: '#FA8782',
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(BackEnd, {})
}, {
  name: 'Institucional',
  slug: 'institucional',
  color: '#0094FF',
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(Institutional, {})
}, {
  name: 'Tecnologia',
  slug: 'tecnologia',
  color: '#000000',
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(Technology, {})
}];
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
;// CONCATENATED MODULE: ./src/components/CategoriesSection/styles.ts

var Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Background",
  componentId: "sc-12no7le-0"
})(["background:var(--highlight-blue);"]);
var StyledSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "styles__StyledSection",
  componentId: "sc-12no7le-1"
})(["padding:2.5rem 0;width:85%;max-width:var(--max-width);margin:0 auto;@media (min-width:1024px){padding:4.25rem 0;max-width:1170px;}"]);
var List = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "styles__List",
  componentId: "sc-12no7le-2"
})(["display:flex;flex-direction:column;gap:2.5rem;@media (min-width:1024px){flex-direction:row;justify-content:space-between;}"]);
var Card = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "styles__Card",
  componentId: "sc-12no7le-3"
})(["border-radius:20px;border:1px solid var(--text-color-secondary);transition:background,box-shadow,border-color 0.3s ease-in-out;&:hover{border-color:", ";background:", ";box-shadow:0px 2px 7px rgba(0,0,0,0.45);}a{display:flex;align-items:center;padding:0.75rem 1.25rem 0.75rem 1.5rem;}span{display:block;font-size:1.25rem;font-weight:700;color:var(--text-color-secondary);}@media (min-width:1024px){height:12.75rem;width:10.188rem;a{height:100%;width:100%;flex-direction:column;justify-content:center;align-items:center;gap:2rem;}}"], function (_ref) {
  var background = _ref.background;
  return background ? background : 'var(--highlight-blue)';
}, function (_ref2) {
  var background = _ref2.background;
  return background ? background : 'var(--highlight-blue)';
});
var CardIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__CardIcon",
  componentId: "sc-12no7le-4"
})(["margin-right:1.25rem;@media (min-width:1024px){margin-right:0;svg{width:80px;height:80px;}}"]);
var ArrowContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__ArrowContainer",
  componentId: "sc-12no7le-5"
})(["margin-left:auto;"]);
;// CONCATENATED MODULE: ./src/components/CategoriesSection/index.tsx








function CategoriesSection() {
  var isDesktop = (0,useMediaQuery/* default */.Z)('(min-width: 1024px)');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Background, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledSection, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
        color: "#fff",
        children: "ASSUNTOS MAIS RELEVANTES:"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(List, {
        children: categoriesList.map(function (category) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Card, {
            background: category.color,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)((link_default()), {
              href: "/categorias/".concat(category.slug),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CardIcon, {
                children: category.icon
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: category.name
              }), !isDesktop ? /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowContainer, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Arrow, {})
              }) : null]
            })
          }, category.name);
        })
      })]
    })
  });
}

/***/ }),

/***/ 98:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/images/logo.webp
/* harmony default export */ var logo = ({"src":"/_next/static/media/logo.d6332de7.webp","height":55,"width":222,"blurDataURL":"data:image/webp;base64,UklGRmoAAABXRUJQVlA4WAoAAAAQAAAABwAAAQAAQUxQSBEAAAAAvIcyU0lRPkinlDJWS1VASQBWUDggMgAAALABAJ0BKggAAgACQDgloAJ0AQ7+AuwA/v30hV51+vfLq/E78Ex3l7en4nfgk4d3kygA","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/images/menu-icon.png
/* harmony default export */ var menu_icon = ({"src":"/_next/static/media/menu-icon.d76c8117.png","height":32,"width":32,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAADFBMVEUAAP9MaXEAAP8AAP+atJniAAAAA3RSTlOvAEknUie3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAG0lEQVQImWNghgIGJihgYIQCBkwAl4IrhmkHAA3IAGHKM3DWAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
;// CONCATENATED MODULE: ./src/components/Header/styles.ts

var StyledHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
  displayName: "styles__StyledHeader",
  componentId: "sc-7aet2n-0"
})(["margin:0 auto;height:6.25rem;background-color:var(--text-color-secondary);position:fixed;left:0;right:0;box-shadow:0 0 4px 3px rgba(0,0,0,0.2);width:100%;z-index:100;"]);
var StyledNav = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
  displayName: "styles__StyledNav",
  componentId: "sc-7aet2n-1"
})(["@media (min-width:1100px){display:flex;height:100%;}"]);
var LogoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__LogoWrapper",
  componentId: "sc-7aet2n-2"
})(["display:flex;align-items:center;justify-content:space-between;padding:1.5rem;padding-bottom:1rem;a img{object-fit:contain;}@media (min-width:1100px){width:20%;margin-right:auto;}@media (min-width:1100px) and (max-width:1400px){a img{width:9rem;height:auto;}}@media (min-width:1400px){padding-left:2rem;padding-bottom:1.5rem;a img{width:11rem;}}@media (min-width:1500px){padding-left:3rem;}"]);
var MenuList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "styles__MenuList",
  componentId: "sc-7aet2n-3"
})(["overflow:hidden;background-color:var(--text-color-secondary);padding:0 1.5rem 0;display:flex;flex-direction:column;justify-content:space-between;transition:height 0.3s linear;margin:0;margin-top:-0.4rem;li{+ li{margin-top:1.1rem;}&:last-child{margin-bottom:1.1rem;}&:first-child{margin-top:1.1rem;}.active{color:var(--highlight-blue);}}&.open{height:16rem;@media (min-width:1100px){height:initial;}}&.close{height:0;@media (min-width:1100px){height:initial;}}@media (min-width:1100px){height:100%;width:100%;flex-direction:row;align-items:center;justify-content:flex-start;gap:1.5rem;padding:0;margin-left:2.5rem;li{text-align:center;a{font-size:0.875rem;}&:first-child{margin-top:0;}&:last-child{margin-bottom:0;margin-right:1rem;}}li + li{margin-top:0;}}@media (min-width:1400px){gap:2.5rem;margin-left:4.5rem;}@media (min-width:1600px){margin-left:8.5rem;}"]);
var MenuItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "styles__MenuItem",
  componentId: "sc-7aet2n-4"
})(["div{position:relative;&::before{content:'';position:absolute;height:2px;bottom:-4px;left:2px;right:0;background-color:var(--highlight-blue);transform-origin:left;transform:scaleX(0);transition:transform 0.3s ease-in-out;}&:hover::before,&:focus::before{transform:scaleX(0.6);}}@media (min-width:1400px){div{font-size:1rem;}}"]);
var MobileBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styles__MobileBtn",
  componentId: "sc-7aet2n-5"
})(["outline:none;background-color:var(--text-color-secondary);border:none;@media (min-width:1100px){display:none;}"]);
var Cta = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "styles__Cta",
  componentId: "sc-7aet2n-6"
})(["display:none;@media (min-width:1100px){width:28.625rem;max-width:430px;margin-left:auto;background-color:var(--highlight-blue);color:var(--text-color-secondary);font-weight:bold;font-size:1.125rem;padding:0.5rem 1.5rem;text-transform:uppercase;display:flex;align-items:center;justify-content:space-evenly;transition:background-color 0.5s;&:hover,&:focus{background-color:#3532ff;}svg{width:3.75rem;transition:transform 0.5s;}&:hover svg,&:focus svg{transform:scale(1.1);}}@media (min-width:1124px){gap:0.5rem;}@media (min-width:1400px){font-size:1.125rem;min-width:28.625rem;}"]);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/Header/index.tsx








function Header() {
  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  function toogleMenu() {
    setIsOpen(!isOpen);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledHeader, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledNav, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LogoWrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          rel: "noreferrer",
          href: "https://kenzie.com.br",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: logo,
            alt: "Kenzie Academy",
            width: "222",
            height: "55"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(MobileBtn, {
          onClick: toogleMenu,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: menu_icon,
            alt: "\xCDcone Menu",
            width: "32",
            height: "32"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MenuList, {
        className: isOpen ? 'open' : 'close',
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MenuItem, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            rel: "noreferrer",
            href: "https://kenzie.com.br/quem-somos",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: "Quem somos"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(MenuItem, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            rel: "noreferrer",
            href: "https://kenzie.com.br/curriculo",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: "Forma\xE7\xE3o"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(MenuItem, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            rel: "noreferrer",
            href: "https://kenzie.com.br/pagamento",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: "Pagamento"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(MenuItem, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            rel: "noreferrer",
            href: "https://kenzie.com.br/parceiras",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: "Para empresas"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(MenuItem, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            rel: "noreferrer",
            href: "https://kenzie.com.br/faq",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: "D\xFAvidas"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(MenuItem, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/",
            legacyBehavior: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              rel: "noreferrer",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "active",
                children: "Blog"
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(MenuItem, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            rel: "noreferrer",
            href: "https://kenzie.gupy.io/",
            target: "_blank",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: "Trabalhe conosco"
            })
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Cta, {
        href: "https://inscricao.kenzie.com.br",
        rel: "noreferrer",
        children: ["Quero ser programador(a)", /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
          width: "56",
          height: "16",
          viewBox: "0 0 56 16",
          fill: "none",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M55.2765 8.42196C55.667 8.03143 55.667 7.39827 55.2765 7.00774L48.9125 0.643781C48.522 0.253257 47.8888 0.253257 47.4983 0.643781C47.1078 1.03431 47.1078 1.66747 47.4983 2.05799L53.1551 7.71485L47.4983 13.3717C47.1078 13.7622 47.1078 14.3954 47.4983 14.7859C47.8888 15.1764 48.522 15.1764 48.9125 14.7859L55.2765 8.42196ZM0.388794 8.71484L54.5694 8.71485L54.5694 6.71485L0.388794 6.71484L0.388794 8.71484Z",
            fill: "white"
          })
        })]
      })]
    })
  });
}

/***/ }),

/***/ 9252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PostCard; }
});

// EXTERNAL MODULE: ./src/helpers/categories.ts
var categories = __webpack_require__(5676);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(1953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(1655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/CardSkeleton/index.tsx



function CardSkeleton() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    style: {
      flexGrow: '1'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
        variant: "rectangular",
        width: 356,
        height: 246
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
          pt: 0.5
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
          width: "60%"
        })]
      })]
    })
  });
}
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
;// CONCATENATED MODULE: ./src/components/PostCard/styles.ts


var CardContainer = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "styles__CardContainer",
  componentId: "sc-3mlwdv-0"
})(["height:20rem;width:21.875rem;border-radius:1rem;transition:box-shadow 0.3s ease-in-out;flex-grow:1;&:hover{box-shadow:4px 4px 5px 0 rgba(0,0,0,0.2);.bg-content{background:var(--text-color-secondary);}}@media (min-width:400px){min-width:23.875rem;}@media (min-width:1100px){max-width:22.313rem;}@media (min-width:1400px){max-width:25.513rem;}"]);
var StyledLink = (0,styled_components_browser_esm/* default */.ZP)((link_default())).withConfig({
  displayName: "styles__StyledLink",
  componentId: "sc-3mlwdv-1"
})(["height:100%;;"]);
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Header",
  componentId: "sc-3mlwdv-2"
})(["height:50%;background:url(", ") no-repeat center;background-size:cover;border-top-left-radius:1rem;border-top-right-radius:1rem;position:relative;"], function (_ref) {
  var image = _ref.image;
  return image ? image : '';
});
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Content",
  componentId: "sc-3mlwdv-3"
})(["height:50%;background:#f5f5f5;border-bottom-left-radius:1rem;border-bottom-right-radius:1rem;padding:2rem 1rem;display:flex;flex-direction:column;flex-grow:1;transition:background 0.3s ease-in-out;h3{font-size:1.125rem;font-weight:600;font-family:Montserrat,sans-serif;margin-bottom:0.8rem;}p{margin-top:auto;}@media (min-width:1024px){padding-top:2.5rem;}"]);
var Category = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Category",
  componentId: "sc-3mlwdv-4"
})(["background:", ";color:var(--text-color-secondary);padding:0.5rem 2rem;position:absolute;bottom:-15px;font-size:1rem;"], function (_ref2) {
  var color = _ref2.color;
  return color ? color : 'var(--highlight-blue)';
});
;// CONCATENATED MODULE: ./src/components/PostCard/index.tsx






function PostCard(_ref) {
  var post = _ref.post,
      _ref$showCategory = _ref.showCategory,
      showCategory = _ref$showCategory === void 0 ? false : _ref$showCategory,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
  var category = (0,categories/* translateCategoryById */.b7)(post.category);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: !isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(CardContainer, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledLink, {
        href: "/".concat(post.slug),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header, {
          image: post.media,
          children: showCategory ? /*#__PURE__*/(0,jsx_runtime.jsx)(Category, {
            color: category.color,
            children: category.name
          }) : null
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Content, {
          className: "bg-content",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            children: post.title
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: [post.readingTime, " min de leitura"]
          })]
        })]
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(CardSkeleton, {})
  });
}

/***/ }),

/***/ 2422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
;// CONCATENATED MODULE: ./src/components/Title/styles.ts

var StyledTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "styles__StyledTitle",
  componentId: "sc-1q2psyb-0"
})(["font-size:1.625rem;font-weight:800;color:", ";margin-bottom:2.5rem;text-transform:uppercase;@media (min-width:1024px){margin-bottom:4.5rem;font-size:3rem;}"], function (_ref) {
  var color = _ref.color;
  return color ? color : 'var(--highlight-blue)';
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/Title/index.tsx


function Title(_ref) {
  var children = _ref.children,
      color = _ref.color;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTitle, {
    color: color,
    children: children
  });
}

/***/ }),

/***/ 5676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b7": function() { return /* binding */ translateCategoryById; },
/* harmony export */   "bd": function() { return /* binding */ categories; }
/* harmony export */ });
/* unused harmony exports categoriesSlugs, categoriesIds */
var categories = {
  1379: {
    name: 'Back-End',
    color: '#FA8782'
  },
  1362: {
    name: 'Carreira',
    color: '#0000ff'
  },
  1382: {
    name: 'CSS',
    color: '#0000ff'
  },
  1363: {
    name: 'Cultura Tech',
    color: '#750088'
  },
  1378: {
    name: 'Front-End',
    color: '#FA463C'
  },
  1364: {
    name: 'Institucional',
    color: '#0094FF'
  },
  1366: {
    name: 'Mercado de Trabalho',
    color: '#B20000'
  },
  1381: {
    name: 'Programação',
    color: '#ff1493'
  },
  1383: {
    name: 'HTML',
    color: '#0000ff'
  },
  1384: {
    name: 'Javascript',
    color: '#0000ff'
  },
  1367: {
    name: 'Tecnologia',
    color: '#000'
  },
  1385: {
    name: 'Python',
    color: '#0000ff'
  },
  1: {
    name: 'Uncategorized',
    color: '#0000ff'
  }
};
var categoriesSlugs = (/* unused pure expression or super */ null && (['back-end', 'carreira', 'css', 'cultura-tech', 'front-end', 'institucional', 'mercado-de-trabalho', 'programacao', 'html', 'javascript', 'tecnologia', 'python', 'uncategorized']));
var categoriesIds = {
  'back-end': 1379,
  carreira: 1362,
  css: 1382,
  'cultura-tech': 1363,
  'front-end': 1378,
  institucional: 1364,
  'mercado-de-trabalho': 1366,
  programacao: 1381,
  html: 1383,
  javascript: 1384,
  tecnologia: 1367,
  python: 1385,
  uncategorized: 1
};
function translateCategoryById(id) {
  return categories[id];
}

/***/ })

}]);